import { render } from "./_form.vue?vue&type=template&id=e26c564a"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/parts/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e26c564a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e26c564a', __exports__)) {
    console.log('reload')
    api.reload('e26c564a', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=e26c564a", () => {
    console.log('re-render')
    api.rerender('e26c564a', render)
  })

}


export default __exports__